import { useCallback, useEffect, useState } from 'react';

import { useTypesense } from './useTypesense';

export const useSimpleTypesense = (collection, searchBy) => {
  const { typesenseClient } = useTypesense({}, true);
  const [results, setResults] = useState([]);
  const [search, setSearch] = useState('');

  const fetchResults = useCallback(async () => {
    const query = await typesenseClient
      ?.collections(collection)
      .documents()
      .search({
        q: search || '*',
        query_by: searchBy,
        per_page: 25,
      });

    setResults(query?.hits?.map((result) => result.document) || []);
  }, [collection, search, searchBy, typesenseClient]);

  useEffect(() => {
    if (typesenseClient) {
      fetchResults();
    }
  }, [typesenseClient, collection, search, searchBy, fetchResults]);

  return { results, currentSearch: search, setSearch };
};
